import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { InputText } from 'views/components/atoms/InputText';
import { MAX_WIDTH } from 'views/constants';
import { Icon } from 'views/components/molecules/Icon';

const Wrapper = styled.div`
  margin: auto;
  width: ${MAX_WIDTH};
`;

interface SearchBarProps {
  onChange(value: string): void;
  placeholder: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onChange, placeholder }) => (
  <Wrapper>
    <InputText
      onChange={onChange}
      placeholder={placeholder}
      type="text"
      label={<Icon type="search" />}
      required
      autoFocus
    />
  </Wrapper>
);

interface AppSearchFormProps {
  onSearchInputChange(input: string): void;
  placeholder: string;
}

export const AppSearchForm: React.FC<AppSearchFormProps> = ({
  onSearchInputChange,
  placeholder,
}) => {
  const handleChangeInput = useCallback(
    (input: string): void => {
      onSearchInputChange(input);
    },
    [onSearchInputChange]
  );

  return <SearchBar onChange={handleChangeInput} placeholder={placeholder} />;
};
